import { useCurrentClient, useCurrentNetwork } from "@mysten/dapp-kit-react";
import type { SuiGrpcClient } from "@mysten/sui/grpc";

/**
 * Returns the active `SuiGrpcClient` and network name.
 *
 * dapp-kit v2 has no query hooks of its own — `useCurrentClient()` plus your own
 * react-query is the supported read pattern (see `hooks/sui/queries.ts`). The
 * network is returned alongside so it can be part of the query key; switching
 * networks swaps the client and must not serve another network's cached data.
 *
 * Thanks to the `Register` declaration in `@/lib/sui/dappKit`, `useCurrentClient`
 * already narrows to `SuiGrpcClient`; the annotation is here for readers.
 */
export function useSuiGrpcClient(): { client: SuiGrpcClient; network: string } {
  const client = useCurrentClient();
  const network = useCurrentNetwork();

  return { client, network };
}
